/**
 * <ry-card>
 *
 * Card container. CSS-only by default.
 * Add `interactive` attribute for clickable cards with href navigation.
 *
 * Usage:
 * <ry-card>Static content</ry-card>
 * <ry-card interactive href="/demos/goap">Clickable card</ry-card>
 * <ry-card interactive>Emits ry:click on click</ry-card>
 */

import { RyElement } from '../core/ry-element.js';

export class RyCard extends RyElement {
  setup(): void {
    if (!this.hasAttribute('interactive')) return;

    if (!this.hasAttribute('tabindex')) {
      this.setAttribute('tabindex', '0');
    }
    this.setAttribute('role', 'link');

    this.on(this, 'click', this.#handleClick);
    this.on(this, 'keydown', this.#handleKeydown);
  }

  #handleClick = (e: MouseEvent): void => {
    // Ignore clicks on links/buttons inside the card
    const target = e.target as HTMLElement;
    if (target.closest('a, button, ry-button')) return;

    const href = this.getAttribute('href');
    if (href) {
      window.location.href = href;
    }
    this.emit('click', { originalEvent: e });
  };

  #handleKeydown = (e: KeyboardEvent): void => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.click();
    }
  };
}

customElements.define('ry-card', RyCard);
